// Theme customization: extracted from main.ts so that file can stay as close
// to upstream as possible (fewer merge conflicts when pulling updates).
// The React app's loginAndRegister() already handles register and
// password-reset links based on the feature flag; re-clicking the native
// anchor would navigate away from the portal page the app just opened, so the
// synthetic click must be skipped for those actions.
const CUSTOM_INTERCEPTED_LINK_PATTERNS = ['create_account', 'reset_password'];

export const shouldSkipSyntheticLinkClick = (element: HTMLElement): boolean => {
  const href = element.getAttribute('href') ?? '';

  return CUSTOM_INTERCEPTED_LINK_PATTERNS.some((pattern) => href.includes(pattern));
};
